<template>
  <a class="btn" :type="type" @click.prevent="click" :class="cssClass">
    <slot />
  </a>
</template>

<script>
export default {
  name: 'app-button',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    secondary: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cssClass() {
      return {
        'btn-secondary': this.secondary,
        'btn_inactive': this.disabled
      }
    }
  },
  methods: {
    click(e) {
      if (!this.disabled) {
        this.$emit('click', e)
      }
    }
  }
}
</script>
